<template>
  <div class="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
    <div v-for="item in resources" :key="item.slug || item.url || item.id">
      <div class="relative">
        <img
          :src="getThumbnail(item)"
          class="w-full min-w-[156px] aspect-video rounded-[10px] object-cover cursor-pointer"
          @click="navigatePage(item)"
        />
      </div>
      <div class="flex flex-col pt-[6px]">
        <div class="flex flex-row items-center gap-[6px]">
          <img
            class="w-[12px] h-[12px] flex-shrink-0"
            :src="getTypeIconSrc(item)"
            alt="type-icon"
          />
          <span class="text-[0.75rem] leading-[1rem] font-medium text-[#ECEBEB] tracking-[-0.12px]">
            {{ item.pastors[0] }}
          </span>
        </div>
        <span
          v-if="formatSermonDate(item.date)"
          class="text-[0.75rem] leading-[1rem] font-medium text-[#ECEBEB] tracking-[-0.12px]"
        >
          {{ formatSermonDate(item.date) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { openUrl } from '@/utils/browser-helper';
import { getThumbnail, getTypeIconSrc, formatSermonDate } from '@/utils/library-helpers.js';
import { trackContentClick } from '@/utils/analytics';

export default {
  props: {
    resources: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getThumbnail,
    getTypeIconSrc,
    formatSermonDate,
    async navigatePage(item) {
      const slug = item.slug;
      const url = item.url;
      if (slug !== undefined) {
        trackContentClick({
          contentType: 'sermon',
          contentId: slug,
          title: item.title,
          sourceSection: 'library-search-results',
          destination: `/library/sermon/${slug}`,
          isExternal: false,
          source: 'library-search-results',
        });
        this.$router.push(`/library/sermon/${slug}`);
      } else {
        trackContentClick({
          contentType: 'sermon',
          contentId: url,
          title: item.pastors?.[0] || 'Sermon',
          sourceSection: 'library-search-results',
          destination: url,
          isExternal: true,
          source: 'library-search-results',
        });
        await openUrl(
          { url },
          {
            title: item.pastors?.[0] || 'Sermon',
            source: 'library-sermon',
            page: 'Library',
          },
        );
      }
    },
  },
};
</script>
